const offerteform = {
    init: () => {
        const carClass = $('.js-car-class').attr('data-value');
        const hasError = $('.js-form-error');
        const toggleTrigger = $('.js-toggle-trigger');
        const triggerContainer = $('.js-trigger-container');
        const merkSelect = $('.js-merkSelect');
        const modelSelect = $('.js-modelSelect');
        const brandPredefined = $('.js-car-brand').attr('data-value');
        const modelPredefined = $('.js-car-model').attr('data-value');

        if(hasError.length > 0) {
            const modalId = hasError.attr('data-form');
            $('.js-modal[data-form="' + modalId + '"]').modal();
            triggerContainer.parent().toggleClass('is-triggered');
        }

        if(toggleTrigger.length > 0) {
            toggleTrigger.click(() => {
                triggerContainer.parent().toggleClass('is-triggered');
            });
        }

        if(carClass) {
            predefine($('.js-klasseInput'), carClass);
        }

        if(merkSelect) {
            merkSelect.append($('.js-merkSelect option').remove().sort(function(a, b) {
                const at = $(a).text(), bt = $(b).text();
                return (at > bt)?1:((at < bt)?-1:0);
            }));

            merkSelect.find('option:eq(0)').prop('selected', true);

            if(brandPredefined && modelPredefined) {
                $('.js-merkSelect option[value="' + brandPredefined + '"]').prop('selected', true);
            }

            const brandSlug = merkSelect.val();

            if(brandSlug) {
                getModels(brandSlug, modelSelect, modelPredefined);
            }

            merkSelect.change(() => {
                const brandSlug = merkSelect.val();
                const brandName = merkSelect.find('option:selected').text();
                const merkValue = $('#merkValue');

                if(merkValue) {
                    merkValue.remove();
                }

                $('<input>').attr({
                    type: 'hidden',
                    id: 'merkValue',
                    name: 'merkSelect',
                    value: brandName
                }).insertAfter(merkSelect);

                if(brandSlug) {
                    getModels(brandSlug, modelSelect, modelPredefined);
                }
            });
        }
    }
};

function getModels(brandSlug, modelSelect, modelPredefined) {
    modelSelect.empty();

    $.getJSON(`/api/brands/${brandSlug}.json`, function (data) {
        $.each(data.models, function (key, value) {
            modelSelect.append($("<option></option>")
                .attr("value", value).text(value));
        })
    }).done(function() {
        $('.js-modelSelect option[value="' + modelPredefined + '"]').prop("selected", true);
    });
}

function predefine($input, value)  {
    if ($input.length > 0) {
        $input.val(value);
    }
}

export default offerteform;


// WEBPACK FOOTER //
// ./resources/js/modules/offerteform.js